export default __webpack_public_path__ + "static/media/minus-circle-neutral.10895ea6.svg";